var _path, _line, _line2, _line3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58789 4.61548H21.414V26.0001C21.414 26.8285 20.7424 27.5001 19.914 27.5001H4.08789C3.25946 27.5001 2.58789 26.8285 2.58789 26.0001V4.61548Z",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 8.80762,
    x2: 24,
    y2: 8.80762,
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.84766,
    y1: 12.4231,
    x2: 8.84766,
    y2: 23.8462,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.1094,
    y1: 12.4231,
    x2: 15.1094,
    y2: 23.8462,
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4782 1C8.55647 1 8.17386 3.42308 8.34777 4.63462H14.608C14.7821 3.42308 14.3999 1 11.4782 1Z",
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3c914b16273fbf8b49232c36acc83abf.svg";
export { ForwardRef as ReactComponent };